import React, { useState, useMemo } from 'react'

import { useSelector } from 'react-redux'

import queryString from 'query-string'

import Grid from '@material-ui/core/Grid'
import Tooltip from '@material-ui/core/Tooltip'
import ButtonBase from '@material-ui/core/ButtonBase'
import SvgIcon from '@material-ui/core/SvgIcon'

import { makeStyles, withStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router-dom'
import { getViolationIndex } from '../../../utils'

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(0, 0, 0, 0.54)',
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 12,
    leaveTouchDelay: 10000
  },
  arrow: {
    color: 'rgba(0,0,0,0.54)'
  }
}))(Tooltip)

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    height: '155px',
    width: '160px'
  },
  topGreenBtn: {
    height: '40px',
    width: '75px'
  },
  topGreenIcon: {
    width: '75px',
    height: '40px'
  },
  leftBlueBtn: {
    width: '40px',
    height: '75px'
  },
  leftBlueIcon: {
    width: '40px',
    height: '75px'
  },
  rightBlueBtn: {
    width: '40px',
    height: '75px'
  },
  rightBlueIcon: {
    width: '40px',
    height: '75px'
  },
  centerButton: {
    width: '60px',
    height: '60px'
  },
  centerIcon: {
    height: '60px',
    width: '60px'
  },
  bottomGreenBtn: {
    width: '75px',
    height: '40px'
  },
  bottomGreenIcon: {
    width: '75px',
    height: '40px'
  }
}))

const InteractiveButton = (props) => {
  const classes = useStyles()
  const { handleClickStatus, handleShareClick } = props

  const Captures = useSelector(state => state.violations.violations.captures)
  const PageLimit = useSelector(state => state.selection.PageCaptureLimit)
  const Permissions = useSelector(state => state.auth.permissions)

  // get the range of captures to filter based on the current view; in the case of single view, calculate the specific index

  const canResolve = Permissions && Permissions.length ? Permissions.findIndex((permissionKey) => permissionKey === 'violation-resolver') !== -1 : false

  const [captureInfo, setCaptureInfo] = useState(null)
  const [parsedProps, setParsedProps] = useState({ view: '', page: 0, captureTrgts: null })
  const [isHoveringLeft, setIsHoveringLeft] = useState(false)
  const [isHoveringRight, setIsHoveringRight] = useState(false)
  const [isHoveringTop, setIsHoveringTop] = useState(false)
  const [isHoveringBottom, setIsHoveringBottom] = useState(false)
  const [isHoveringCenter, setIsHoveringCenter] = useState(false)

  const [isDisabledLeft, setIsDisabledLeft] = useState(false)
  const [isDisabledRight, setIsDisabledRight] = useState(false)
  const [isDisabledBottom, setIsDisabledBottom] = useState(false)
  const [isDisabledTop, setIsDisabledTop] = useState(false)
  const [isDisabledCenter, setIsDisabledCenter] = useState(false)

  useMemo(() => {
    if (props.location && Boolean(props.location.search) && typeof PageLimit === 'number') {
      try {
        const searchProps = queryString.parse(props.location.search)

        if (searchProps && typeof searchProps === 'object' && Boolean(searchProps.view)) {
          // !!TO DO: This logic is duplicated numerous times in various files. Need to move to util or move this memo to a parent component of all files in which it is used.
          const captureTrgts = (() => {
            switch (searchProps.view) {
              case 'single': {
                try {
                  // capture (singular) returns a number string, with a 1 based index
                  return parseInt(searchProps.capture) || null
                } catch (err) {
                  return null
                }
              }
              case 'grid': {
                try {
                  // active captures (plural) in grid view returns an array (considered truthy even when empty so the following logic will work as expected)
                  return JSON.parse(searchProps.activeCaptures) || null
                } catch (err) {
                  return null
                }
              }
              case 'list': {
                try {
                  // active capture (singular) in list view returns a number string, with a 0 based index.
                  // Previously this used the same logic as the 'single' case. However as it was 0 based, the `parseInt(searchProps.activeCapture) || null` always returned null at the first index as 0 is falsey
                  const parsedCaptureNum = parseInt(searchProps.activeCapture)
                  if (!isNaN(parsedCaptureNum)) {
                    return parsedCaptureNum
                  } else {
                    return null
                  }
                } catch (err) {
                  return null
                }
              }
              default: return null
            }
          })()

          const page = (() => {
            if (searchProps.view === 'single' && typeof captureTrgts === 'number') { return Math.floor((captureTrgts - 1) / PageLimit) + 1 }
            return parseInt(searchProps.page) || 0
          })()

          setParsedProps({ view: searchProps.view, page, captureTrgts })
        }
      } catch (err) {
        console.log(err)
      }
    }
  }, [props.location, PageLimit])

  useMemo(() => {
    if (Boolean(parsedProps.view) && parsedProps.captureTrgts !== null && typeof parsedProps.page === 'number' && Array.isArray(Captures) && Boolean(Captures.length)) {
      if (parsedProps.view === 'single' || parsedProps.view === 'list') {
        const violationInfo = (() => {
          if (typeof parsedProps.captureTrgts === 'number') {
            const captureIx = getViolationIndex({ captureNum: parsedProps.captureTrgts, pageLimit: PageLimit, page: parsedProps.page, currentView: parsedProps.view })
            if (typeof captureIx === 'number' && Array.isArray(Captures) && Boolean(Captures.length)) { return Captures[captureIx] }
          }

          return {}
        })()

        setCaptureInfo(violationInfo)
      }

      if (parsedProps.view === 'grid' && Array.isArray(parsedProps.captureTrgts)) {
        const activeViolations = parsedProps.captureTrgts.reduce((arr, captureNum) => {
          const captureIx = getViolationIndex({ captureNum, pageLimit: PageLimit, page: parsedProps.page, currentView: parsedProps.view })
          const violationInfo = (() => {
            if (typeof captureIx === 'number' && Array.isArray(Captures) && Boolean(Captures.length)) { return Captures[captureIx] }
            return {}
          })()

          if (violationInfo && Boolean(violationInfo.violationID)) {
            arr.push({ ...violationInfo })
          }

          return arr
        }, [])

        setCaptureInfo(activeViolations)
      }
    }
  }, [parsedProps, Captures, PageLimit])

  useMemo(() => {
    const getStatusDisability = (statusFlag) => {
      switch (statusFlag) {
        case 'U': {
          setActionDisablity(false, false, false, false, false, false)
          break
        }
        case 'P': {
          setActionDisablity(false, true, false, false, false)
          break
        }
        case 'N': {
          setActionDisablity(false, false, false, true, false)
          break
        }
        case 'H': {
          setActionDisablity(false, false, true, false, false)
          break
        }
        case 'S': {
          setActionDisablity(false, false, false, false, true)
          break
        }
        default: break
      }
    }

    const setActionDisablity = (share, problem, hold, notProblem, resolved) => {
      setIsDisabledCenter(share)
      setIsDisabledTop(problem)
      setIsDisabledRight(hold)
      setIsDisabledBottom(notProblem)
      setIsDisabledLeft(resolved)
    }

    const setDefaults = () => {
      if (isDisabledBottom) {
        setIsDisabledBottom(false)
      }
      if (isDisabledCenter) {
        setIsDisabledCenter(false)
      }
      if (isDisabledRight) {
        setIsDisabledRight(false)
      }
      if (isDisabledLeft) {
        setIsDisabledLeft(false)
      }
      if (isDisabledTop) {
        setIsDisabledTop(false)
      }
    }

    if (Boolean(parsedProps.view) && parsedProps.captureTrgts !== null) {
      switch (parsedProps.view) {
        case 'grid': {
          if (Array.isArray(captureInfo) && Boolean(captureInfo.length) && captureInfo.length === 1) {
            getStatusDisability(captureInfo[0].statusFlag)
          } else {
            setDefaults()
          }
          break
        }
        case 'single':
        case 'list': {
          if (typeof captureInfo === 'object' && captureInfo !== null && Boolean(captureInfo.violationID)) {
            getStatusDisability(captureInfo.statusFlag)
          } else {
            setDefaults()
          }
          break
        }
        default: break
      }
    }
  }, [parsedProps.view, parsedProps.captureTrgts, captureInfo, isDisabledTop, isDisabledBottom, isDisabledCenter, isDisabledLeft, isDisabledRight])

  const topGreenFill = isDisabledTop ? '#808080' : isHoveringTop ? '#FFA593' : '#a4d164'
  const bottomGreenFill = isDisabledBottom ? '#808080' : isHoveringBottom ? '#96E1A8' : '#a4d164'
  const centerGreenFill = isDisabledCenter ? '#808080' : isHoveringCenter ? '#BEEB7E' : '#a4d164'
  const leftBlueFill = isDisabledLeft || !canResolve ? '#808080' : isHoveringLeft ? '#A6FFFF' : '#3984f7'
  const rightBlueFill = isDisabledRight ? '#808080' : isHoveringRight ? '#ffff91' : '#3984f7'

  return (
    <>
      <Grid container direction='row' className={classes.buttonContainer}>
        <Grid container item direction='column'>
          {/* Top Green button */}
          <Grid container item direction='row' justify='center'>
            <>
              {
                !isDisabledTop
                  ? (
                    <LightTooltip title='Problem' arrow placement='top'>
                      <ButtonBase
                        className={classes.topGreenBtn}
                        onClick={() => { handleClickStatus('P') }}
                        onMouseEnter={() => setIsHoveringTop(true)}
                        onMouseLeave={() => setIsHoveringTop(false)}
                      >
                        <SvgIcon className={classes.topGreenIcon} viewBox='0 0 66 35'>
                          <path
                            d='M33.125+0.5C27.6022+0.5+23.125+4.97715+23.125+10.5C23.125+11.6492+23.4245+12.7223+23.7812+13.75C23.2011+13.8497+22.6047+13.9139+22.0312+14.0312C18.4509+14.7639+15.0088+15.8272+11.7188+17.2188C8.4287+18.6103+5.30102+20.3045+2.375+22.2812C1.72955+22.7173+1.12555+23.2252+0.5+23.6875L11.5625+34.2812C17.7914+30.2786+25.1709+27.9062+33.125+27.9062C41.1443+27.9062+48.5521+30.3118+54.8125+34.375L65.5938+23.5938C65.0125+23.1669+64.4734+22.6855+63.875+22.2812C60.949+20.3045+57.8213+18.6103+54.5312+17.2188C51.2412+15.8272+47.7679+14.7639+44.1875+14.0312C43.6209+13.9153+43.0406+13.8487+42.4688+13.75C42.8255+12.7223+43.125+11.6492+43.125+10.5C43.125+4.97715+38.6478+0.5+33.125+0.5Z'
                            opacity='1'
                            fill={topGreenFill}
                          />
                          <path
                            d='M33.1284+5.31131L33.144+5.32724L33.8461+6.04374L36.1164+8.36042L35.4087+9.09373L33.1383+6.77705L30.8185+9.14847L30.1164+8.43197L32.4362+6.06055L32.4206+6.04463L33.1284+5.31131Z'
                            opacity='1'
                            fill='#ffffff'
                          />
                        </SvgIcon>
                      </ButtonBase>
                    </LightTooltip>)
                  : (
                    <ButtonBase
                      className={classes.topGreenBtn}
                      onClick={() => { handleClickStatus('P') }}
                      onMouseEnter={() => setIsHoveringTop(true)}
                      onMouseLeave={() => setIsHoveringTop(false)}
                      disabled
                    >
                      <SvgIcon className={classes.topGreenIcon} viewBox='0 0 66 35'>
                        <path
                          d='M33.125+0.5C27.6022+0.5+23.125+4.97715+23.125+10.5C23.125+11.6492+23.4245+12.7223+23.7812+13.75C23.2011+13.8497+22.6047+13.9139+22.0312+14.0312C18.4509+14.7639+15.0088+15.8272+11.7188+17.2188C8.4287+18.6103+5.30102+20.3045+2.375+22.2812C1.72955+22.7173+1.12555+23.2252+0.5+23.6875L11.5625+34.2812C17.7914+30.2786+25.1709+27.9062+33.125+27.9062C41.1443+27.9062+48.5521+30.3118+54.8125+34.375L65.5938+23.5938C65.0125+23.1669+64.4734+22.6855+63.875+22.2812C60.949+20.3045+57.8213+18.6103+54.5312+17.2188C51.2412+15.8272+47.7679+14.7639+44.1875+14.0312C43.6209+13.9153+43.0406+13.8487+42.4688+13.75C42.8255+12.7223+43.125+11.6492+43.125+10.5C43.125+4.97715+38.6478+0.5+33.125+0.5Z'
                          opacity='1'
                          fill={topGreenFill}
                        />
                        <path
                          d='M33.1284+5.31131L33.144+5.32724L33.8461+6.04374L36.1164+8.36042L35.4087+9.09373L33.1383+6.77705L30.8185+9.14847L30.1164+8.43197L32.4362+6.06055L32.4206+6.04463L33.1284+5.31131Z'
                          opacity='1'
                          fill='#ffffff'
                        />
                      </SvgIcon>
                    </ButtonBase>)
              }
            </>
          </Grid>

          <Grid container item direction='row' alignItems='center' justify='space-evenly'>
            {/* Blue left button  */}
            <>
              {
                !isDisabledLeft && canResolve
                  // && Permissions.findIndex((permissionKey) => permissionKey === 'violation-resolver') !== -1
                  ? (
                    <LightTooltip title='Resolved' arrow placement='right'>
                      <ButtonBase
                        className={classes.leftBlueBtn}
                        onClick={() => { handleClickStatus('S') }}
                        onMouseEnter={() => setIsHoveringLeft(true)}
                        onMouseLeave={() => setIsHoveringLeft(false)}
                      >
                        <SvgIcon className={classes.leftBlueIcon} viewBox='0 0 35 66'>
                          <path
                            d='M23.6875+0.25C23.1596+0.955871+22.5879+1.64349+22.0938+2.375C20.117+5.30102+18.4228+8.42871+17.0312+11.7188C15.6397+15.0088+14.5451+18.4509+13.8125+22.0312C13.6954+22.6036+13.6607+23.2021+13.5625+23.7812C12.5187+23.4118+11.4204+23.125+10.25+23.125C4.72715+23.125+0.25+27.6022+0.25+33.125C0.250001+38.6479+4.72715+43.125+10.25+43.125C11.4204+43.125+12.5187+42.8382+13.5625+42.4688C13.6607+43.0479+13.6954+43.6464+13.8125+44.2188C14.5451+47.7991+15.6397+51.2412+17.0312+54.5312C18.4228+57.8213+20.117+60.949+22.0938+63.875C22.5108+64.4924+22.9964+65.0571+23.4375+65.6562L34.375+55.1875C30.1713+48.8563+27.7188+41.2942+27.7188+33.125C27.7188+24.8091+30.2505+17.0859+34.5938+10.6875L23.6875+0.25Z'
                            opacity='1'
                            fill={leftBlueFill}
                          />
                          <path
                            d='M5.06974+33.1309L5.08566+33.1465L5.80216+33.8487L8.11884+36.119L8.85216+35.4112L6.53547+33.1409L8.90689+30.8211L8.19039+30.1189L5.81897+32.4387L5.80305+32.4231L5.06974+33.1309Z'
                            opacity='1'
                            fill='#ffffff'
                          />
                        </SvgIcon>
                      </ButtonBase>
                    </LightTooltip>)
                  : (
                    <ButtonBase
                      className={classes.leftBlueBtn}
                      onClick={() => { handleClickStatus('S') }}
                      onMouseEnter={() => setIsHoveringLeft(true)}
                      onMouseLeave={() => setIsHoveringLeft(false)}
                      disabled
                    >
                      <SvgIcon className={classes.leftBlueIcon} viewBox='0 0 35 66'>
                        <path
                          d='M23.6875+0.25C23.1596+0.955871+22.5879+1.64349+22.0938+2.375C20.117+5.30102+18.4228+8.42871+17.0312+11.7188C15.6397+15.0088+14.5451+18.4509+13.8125+22.0312C13.6954+22.6036+13.6607+23.2021+13.5625+23.7812C12.5187+23.4118+11.4204+23.125+10.25+23.125C4.72715+23.125+0.25+27.6022+0.25+33.125C0.250001+38.6479+4.72715+43.125+10.25+43.125C11.4204+43.125+12.5187+42.8382+13.5625+42.4688C13.6607+43.0479+13.6954+43.6464+13.8125+44.2188C14.5451+47.7991+15.6397+51.2412+17.0312+54.5312C18.4228+57.8213+20.117+60.949+22.0938+63.875C22.5108+64.4924+22.9964+65.0571+23.4375+65.6562L34.375+55.1875C30.1713+48.8563+27.7188+41.2942+27.7188+33.125C27.7188+24.8091+30.2505+17.0859+34.5938+10.6875L23.6875+0.25Z'
                          opacity='1'
                          fill={leftBlueFill}
                        />
                        <path
                          d='M5.06974+33.1309L5.08566+33.1465L5.80216+33.8487L8.11884+36.119L8.85216+35.4112L6.53547+33.1409L8.90689+30.8211L8.19039+30.1189L5.81897+32.4387L5.80305+32.4231L5.06974+33.1309Z'
                          opacity='1'
                          fill='#ffffff'
                        />
                      </SvgIcon>
                    </ButtonBase>)
              }
            </>

            {/* Center Button */}
            <>
              {
                !isDisabledCenter
                  ? (
                    <LightTooltip title='Share Capture' arrow placement='right'>
                      <ButtonBase
                        className={classes.centerButton}
                        onClick={() => { handleShareClick() }}
                        onMouseEnter={() => setIsHoveringCenter(true)}
                        onMouseLeave={() => setIsHoveringCenter(false)}
                      >
                        <SvgIcon className={classes.centerIcon} viewBox='0 0 61 61'>
                          <path
                            d='M30.4877+0.561616C13.9191+0.561608+0.487651+13.9931+0.487651+30.5616C0.487653+47.1302+13.9191+60.5616+30.4877+60.5616C35.6577+60.5616+40.46+59.1458+44.7064+56.8429L36.1439+44.4366C34.398+45.1481+32.4892+45.5616+30.4877+45.5616C22.2034+45.5616+15.4877+38.8459+15.4877+30.5616C15.4877+22.2773+22.2034+15.5616+30.4877+15.5616C38.7719+15.5616+45.4877+22.2774+45.4877+30.5616C45.4877+32.6327+45.0592+34.6108+44.3002+36.4054L56.6752+44.9366C59.0323+40.6526+60.4877+35.7967+60.4877+30.5616C60.4877+13.9931+47.0562+0.561616+30.4877+0.561616Z'
                            opacity='1'
                            fill={centerGreenFill}
                          />
                          <path
                            d='M26.8712+23.4114L22.0587+29.1927L27.0587+35.4114L26.9962+31.6614C30.1746+31.7014+32.7462+34.3806+32.7462+37.7239L38.9337+37.7239C38.9337+31.0965+33.5612+25.7239+26.9337+25.7239L26.9025+23.4739L26.8712+23.4114Z'
                            opacity='1'
                            fill='#ffffff'
                          />
                        </SvgIcon>
                      </ButtonBase>
                    </LightTooltip>)
                  : (
                    <ButtonBase
                      className={classes.centerButton}
                      onClick={() => { handleShareClick() }}
                      onMouseEnter={() => setIsHoveringCenter(true)}
                      onMouseLeave={() => setIsHoveringCenter(false)}
                      disabled
                    >
                      <SvgIcon className={classes.centerIcon} viewBox='0 0 61 61'>
                        <path
                          d='M30.4877+0.561616C13.9191+0.561608+0.487651+13.9931+0.487651+30.5616C0.487653+47.1302+13.9191+60.5616+30.4877+60.5616C35.6577+60.5616+40.46+59.1458+44.7064+56.8429L36.1439+44.4366C34.398+45.1481+32.4892+45.5616+30.4877+45.5616C22.2034+45.5616+15.4877+38.8459+15.4877+30.5616C15.4877+22.2773+22.2034+15.5616+30.4877+15.5616C38.7719+15.5616+45.4877+22.2774+45.4877+30.5616C45.4877+32.6327+45.0592+34.6108+44.3002+36.4054L56.6752+44.9366C59.0323+40.6526+60.4877+35.7967+60.4877+30.5616C60.4877+13.9931+47.0562+0.561616+30.4877+0.561616Z'
                          opacity='1'
                          fill={centerGreenFill}
                        />
                        <path
                          d='M26.8712+23.4114L22.0587+29.1927L27.0587+35.4114L26.9962+31.6614C30.1746+31.7014+32.7462+34.3806+32.7462+37.7239L38.9337+37.7239C38.9337+31.0965+33.5612+25.7239+26.9337+25.7239L26.9025+23.4739L26.8712+23.4114Z'
                          opacity='1'
                          fill='#ffffff'
                        />
                      </SvgIcon>
                    </ButtonBase>)
              }
            </>

            {/* Blue right button */}
            <>
              {
                !isDisabledRight
                  ? (
                    <LightTooltip title='Hold' arrow placement='right'>
                      <ButtonBase
                        className={classes.rightBlueBtn}
                        onClick={() => { handleClickStatus('H') }}
                        onMouseEnter={() => setIsHoveringRight(true)}
                        onMouseLeave={() => setIsHoveringRight(false)}
                      >
                        <SvgIcon className={classes.rightBlueIcon} viewBox='0 0 35 66'>
                          <path
                            d='M11.0687+0.1L0.35+10.8187C4.63925+17.1915+7.16251+24.8719+7.1625+33.1313C7.1625+41.2005+4.70981+48.6595+0.6+54.9438L11.1937+65.9438C11.7117+65.25+12.2709+64.5997+12.7562+63.8813C14.733+60.9552+16.4272+57.8275+17.8188+54.5375C19.2103+51.2474+20.3048+47.8054+21.0375+44.225C21.1528+43.6616+21.2205+43.0762+21.3188+42.5063C22.3271+42.8481+23.3512+43.1313+24.475+43.1313C29.9978+43.1313+34.475+38.6541+34.475+33.1313C34.475+27.6084+29.9978+23.1313+24.475+23.1312C23.3512+23.1312+22.3271+23.4144+21.3188+23.7562C21.2205+23.1863+21.1528+22.6009+21.0375+22.0375C20.3049+18.4571+19.2103+15.0151+17.8188+11.725C16.4272+8.43495+14.733+5.30727+12.7562+2.38125C12.2265+1.59706+11.6372+0.854686+11.0687+0.1Z'
                            opacity='1'
                            fill={rightBlueFill}
                          />
                          <path
                            d='M29.6827+33.1371L29.6668+33.1527L28.9503+33.8549L26.6336+36.1252L25.9003+35.4174L28.217+33.1471L25.8455+30.8273L26.562+30.1252L28.9335+32.445L28.9494+32.4294L29.6827+33.1371Z'
                            opacity='1'
                            fill='#ffffff'
                          />
                        </SvgIcon>
                      </ButtonBase>
                    </LightTooltip>)
                  : (
                    <ButtonBase
                      className={classes.rightBlueBtn}
                      onClick={() => { handleClickStatus('H') }}
                      onMouseEnter={() => setIsHoveringRight(true)}
                      onMouseLeave={() => setIsHoveringRight(false)}
                      disabled
                    >
                      <SvgIcon className={classes.rightBlueIcon} viewBox='0 0 35 66'>
                        <path
                          d='M11.0687+0.1L0.35+10.8187C4.63925+17.1915+7.16251+24.8719+7.1625+33.1313C7.1625+41.2005+4.70981+48.6595+0.6+54.9438L11.1937+65.9438C11.7117+65.25+12.2709+64.5997+12.7562+63.8813C14.733+60.9552+16.4272+57.8275+17.8188+54.5375C19.2103+51.2474+20.3048+47.8054+21.0375+44.225C21.1528+43.6616+21.2205+43.0762+21.3188+42.5063C22.3271+42.8481+23.3512+43.1313+24.475+43.1313C29.9978+43.1313+34.475+38.6541+34.475+33.1313C34.475+27.6084+29.9978+23.1313+24.475+23.1312C23.3512+23.1312+22.3271+23.4144+21.3188+23.7562C21.2205+23.1863+21.1528+22.6009+21.0375+22.0375C20.3049+18.4571+19.2103+15.0151+17.8188+11.725C16.4272+8.43495+14.733+5.30727+12.7562+2.38125C12.2265+1.59706+11.6372+0.854686+11.0687+0.1Z'
                          opacity='1'
                          fill={rightBlueFill}
                        />
                        <path
                          d='M29.6827+33.1371L29.6668+33.1527L28.9503+33.8549L26.6336+36.1252L25.9003+35.4174L28.217+33.1471L25.8455+30.8273L26.562+30.1252L28.9335+32.445L28.9494+32.4294L29.6827+33.1371Z'
                          opacity='1'
                          fill='#ffffff'
                        />
                      </SvgIcon>
                    </ButtonBase>)
              }
            </>
          </Grid>

          <Grid container item direction='row' justify='space-evenly'>
            {/* Bottom Green Button */}
            <>
              {
                !isDisabledBottom
                  ? (
                    <LightTooltip title='Not a Problem' arrow placement='bottom'>
                      <ButtonBase
                        className={classes.bottomGreenBtn}
                        onClick={() => { handleClickStatus('N') }}
                        onMouseEnter={() => setIsHoveringBottom(true)}
                        onMouseLeave={() => setIsHoveringBottom(false)}
                      >
                        <SvgIcon className={classes.bottomGreenIcon} viewBox='0 0 66 35'>
                          <path
                            d='M55.25+0.5C48.9002+4.74172+41.3031+7.24998+33.0938+7.25C24.9897+7.25+17.4569+4.7987+11.1562+0.65625L0.5+10.875C1.13635+11.3296+1.26457+11.5025+1.9375+11.9688C5.55363+14.4745+9.51425+16.987+11.6875+17.9062C14.9776+19.2978+18.4196+20.3924+22+21.125C22.5634+21.2403+23.1488+21.308+23.7188+21.4062C23.3819+22.4079+23.0937+23.4473+23.0938+24.5625C23.0938+30.0853+27.5709+34.5625+33.0938+34.5625C38.6166+34.5625+43.0938+30.0853+43.0938+24.5625C43.0937+23.4367+42.8118+22.3848+42.4688+21.375C43.0288+21.278+43.6013+21.2386+44.1562+21.125C47.7366+20.3924+51.21+19.2978+54.5+17.9062C57.7901+16.5147+60.9177+14.8205+63.8438+12.8438C64.5067+12.3959+65.1081+11.8819+65.75+11.4062L55.25+0.5Z'
                            opacity='1'
                            fill={bottomGreenFill}
                          />
                          <path
                            d='M33.0971+29.751L33.1127+29.7351L33.8149+29.0186L36.0852+26.7019L35.3774+25.9686L33.1071+28.2853L30.7873+25.9139L30.0851+26.6304L32.4049+29.0018L32.3893+29.0177L33.0971+29.751Z'
                            opacity='1'
                            fill='#ffffff'
                          />
                        </SvgIcon>
                      </ButtonBase>
                    </LightTooltip>)
                  : (
                    <ButtonBase
                      className={classes.bottomGreenBtn}
                      onClick={() => { handleClickStatus('N') }}
                      onMouseEnter={() => setIsHoveringBottom(true)}
                      onMouseLeave={() => setIsHoveringBottom(false)}
                      disabled
                    >
                      <SvgIcon className={classes.bottomGreenIcon} viewBox='0 0 66 35'>
                        <path
                          d='M55.25+0.5C48.9002+4.74172+41.3031+7.24998+33.0938+7.25C24.9897+7.25+17.4569+4.7987+11.1562+0.65625L0.5+10.875C1.13635+11.3296+1.26457+11.5025+1.9375+11.9688C5.55363+14.4745+9.51425+16.987+11.6875+17.9062C14.9776+19.2978+18.4196+20.3924+22+21.125C22.5634+21.2403+23.1488+21.308+23.7188+21.4062C23.3819+22.4079+23.0937+23.4473+23.0938+24.5625C23.0938+30.0853+27.5709+34.5625+33.0938+34.5625C38.6166+34.5625+43.0938+30.0853+43.0938+24.5625C43.0937+23.4367+42.8118+22.3848+42.4688+21.375C43.0288+21.278+43.6013+21.2386+44.1562+21.125C47.7366+20.3924+51.21+19.2978+54.5+17.9062C57.7901+16.5147+60.9177+14.8205+63.8438+12.8438C64.5067+12.3959+65.1081+11.8819+65.75+11.4062L55.25+0.5Z'
                          opacity='1'
                          fill={bottomGreenFill}
                        />
                        <path
                          d='M33.0971+29.751L33.1127+29.7351L33.8149+29.0186L36.0852+26.7019L35.3774+25.9686L33.1071+28.2853L30.7873+25.9139L30.0851+26.6304L32.4049+29.0018L32.3893+29.0177L33.0971+29.751Z'
                          opacity='1'
                          fill='#ffffff'
                        />
                      </SvgIcon>
                    </ButtonBase>)
              }
            </>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default withRouter(InteractiveButton)
